const menuItems = [
  {
    anchor: "#home", icon: "fa-home",
    messageId: "menu.home", defaultMessage: "Home"
  },
  {
    anchor: "#events", icon: "fa-music",
    messageId: "menu.events", defaultMessage: "Events"
  },
  {
    anchor: "#contact", icon: "fa-map-marker-alt",
    messageId: "menu.contact", defaultMessage: "Contact"
  },
  {
    anchor: "#performers", icon: "fa-users",
    messageId: "menu.performers", defaultMessage: "Performers"
  },
  {
    anchor: "#features", icon: "fa-th-list",
    messageId: "menu.features", defaultMessage: "Features"
  },
  {
    anchor: "#offer", icon: "fa-tags",
    messageId: "menu.offer", defaultMessage: "Offer"
  },
  {
    anchor: "#pricing", icon: "fa-dollar-sign",
    messageId: "menu.pricing", defaultMessage: "Pricing"
  }
]

export default menuItems
